import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'components/Luxkit/Typography/Heading'
import OfferList, { OfferListV2Item } from 'components/OfferList/OfferList'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import useOfferList from 'hooks/Offers/useOfferList'
import React, { useContext, useMemo } from 'react'

interface Props {
  filters: App.OfferListFilters;
}

function HotelSearchExpandedDestinationOfferList(props: Props) {
  const { filters } = props

  const { searchItem } = useContext(GlobalSearchStateContext)

  const expandedFilters = useMemo((): App.OfferListFilters => ({
    ...filters,
    distanceGt: 0,
    distanceEq: undefined,
  }), [filters])

  const [offerList] = useOfferList(filters)
  const [nearbyOfferList] = useOfferList(expandedFilters)

  const mainOfferCount = offerList.offerIds.length

  const totalCount = offerList.offerIds.length + nearbyOfferList.offerIds.length

  const expandedExtras = useMemo<Array<OfferListV2Item>>(() => ([{
    id: 'expanded-heading',
    position: 'start',
    element: <Heading variant="heading3">
      {mainOfferCount ? `More offers near ${searchItem?.format.mainText}` : `Offers near ${searchItem?.format.mainText}`}
    </Heading>,
    show: 'hasOffers',
  }, {
    id: 'fallback-offers',
    position: 'end',
    element: <VerticalSpacer gap={24}>
      <Heading variant="heading3">Our top exclusive offers</Heading>
      <OfferList
        filters={{
          offerTypes: filters.offerTypes,
        }}
        tileStyle="search"
      />
    </VerticalSpacer>,
    show: totalCount === 0,
  },
  ]), [searchItem?.format.mainText, filters.offerTypes, totalCount, mainOfferCount])

  return <OfferList
    filters={expandedFilters}
    interstitials={expandedExtras}
    tileStyle="search"
  />
}

export default HotelSearchExpandedDestinationOfferList
